import script from "./singleCall.vue?vue&type=script&setup=true&lang=js"
export * from "./singleCall.vue?vue&type=script&setup=true&lang=js"

import "./singleCall.vue?vue&type=style&index=0&id=0dda78a1&lang=scss&scoped=true"

import exportComponent from "D:\\works\\Company项目\\桃小黑\\heitao-im\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dda78a1"]])

export default __exports__